import React, { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import WhatsAppMessageThread from '../components/whatsapp/WhatsAppMessageThread';
import useInboxStream from '../hooks/useInboxStream';

/**
 * Standalone WhatsApp conversation for a single lead, opened from the Sales
 * leads table (the WhatsApp action). Reuses the inbox message thread, keyed by
 * the lead's phone number, inside the app shell (sidebar + header). Live updates
 * come from the shared SSE stream.
 */
const SalesLeadConversation = () => {
  const { phone } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { collapsed } = useSidebar();

  useInboxStream({ enabled: Boolean(phone) });

  const conversation = useMemo(
    () => ({
      phone_number: phone,
      contact_name: location.state?.contactName || ''
    }),
    [phone, location.state]
  );

  const leadId = location.state?.leadId || null;
  const projectId = location.state?.projectId || null;

  const headerName = location.state?.contactName
    ? `WhatsApp · ${location.state.contactName}`
    : 'WhatsApp conversation';

  return (
    <Layout>
      <div
        className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
    ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
  `}>
        <Header data={{ name: headerName }} backArrow={true} onBack={() => navigate(-1)} />
      </div>

      <div
        className={`${collapsed ? 'w-[100%] pl-3' : 'w-[100%]'} mt-[4rem] px-6 py-6 pb-10`}>
        <div
          className="flex overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-sm"
          style={{ height: 'calc(100vh - 8rem)' }}>
          <WhatsAppMessageThread
            key={phone}
            conversation={conversation}
            leadId={leadId}
            projectId={projectId}
            onBack={() => navigate(-1)}
          />
        </div>
      </div>
    </Layout>
  );
};

export default SalesLeadConversation;
